import Controller from '@ember/controller';

export default class ResultsController extends Controller 
{
	queryParams = ['type'];
	type = null;
}